import type { Flower, Season } from '../../types/game'
import { FlowerCard } from './FlowerCard'

interface FlowerFlight {
  id: number
  flower: Flower
  currentSeason: Season
  startX: number
  startY: number
  deltaX: number
  deltaY: number
  width: number
  height: number
}

interface FlowerFlightOverlayProps {
  flights: FlowerFlight[]
}

export function FlowerFlightOverlay({ flights }: FlowerFlightOverlayProps) {
  if (flights.length === 0) {
    return null
  }

  return (
    <div className="flower-flight-overlay">
      {flights.map((flight) => (
        <div
          key={flight.id}
          className="flower-flight"
          style={{
            left: `${flight.startX}px`,
            top: `${flight.startY}px`,
            width: `${flight.width}px`,
            height: `${flight.height}px`,
            '--flower-flight-dx': `${flight.deltaX}px`,
            '--flower-flight-dy': `${flight.deltaY}px`,
          } as React.CSSProperties}
        >
          <FlowerCard
            flower={flight.flower}
            currentSeason={flight.currentSeason}
            className="flower-flight-card"
          />
        </div>
      ))}
    </div>
  )
}
